export const ORDER_EVENT_STATUS_DRAFT = 'Draft'
export const ORDER_EVENT_STATUS_PUBLISHED = 'Published'
export const ORDER_EVENT_STATUS_EXPIRED = 'Expired'
export const ORDER_EVENT_STATUS_ACCEPTED = 'Accepted'
export const ORDER_EVENT_STATUS_REJECTED = 'Rejected'
export const ORDER_EVENT_STATUS_APPROVED = 'Approved'
export const ORDER_EVENT_STATUS_DENIED = 'Denied'
export const ORDER_EVENT_STATUS_FUNDED = 'Funded'
export const ORDER_EVENT_STATUS_COMPLETED = 'Completed'
export const ORDER_EVENT_STATUS_VOIDED = 'Voided'
